import { useEffect, useState } from 'react';
import { useSignupData } from '../signup-data/useSignupData';
import { Data } from 'signup-constants/signupData/Data';
export const useOldSignupEmail = () => {
  const {
    data: email
  } = useSignupData(Data.Email);
  const [oldEmail, setOldEmail] = useState('');
  const mount = () => {
    setOldEmail(email);
  };

  /* eslint-disable-next-line react-hooks/exhaustive-deps */
  useEffect(mount, []);
  return {
    oldEmail
  };
};